export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'displayImage',
    title: that.$l('INDEX.table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayFabricName') || '面料名称',
    field: 'displayFabricName',
    minWidth: 300,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFabricName' },
  },

  {
    title: that.$l('table_lable_fabricCardBarcode') || '面料条码',
    field: 'fabricCardBarcode',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_lable_warehouse_location') || '库位',
    field: 'locationNo',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayWid') || '颜色克重',
    field: 'displayWid',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayWid' },
  },
  {
    title: that.$l('table_label_displayFabricContent') || '面料成分',
    field: 'displayFabricContent',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFabricContent' },
  },
  {
    title: that.$l('table_label_fabricStatus') || '状态',
    field: 'fabricCardStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fabricCardStatus' },
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
